import { render, staticRenderFns } from "./DataViewer.vue?vue&type=template&id=b0a0aab6&scoped=true&"
import script from "./DataViewer.vue?vue&type=script&lang=js&"
export * from "./DataViewer.vue?vue&type=script&lang=js&"
import style0 from "./DataViewer.vue?vue&type=style&index=0&id=b0a0aab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a0aab6",
  null
  
)

export default component.exports